module.exports = __webpack_public_path__ + "media/images/bus/conditions/UCHA-450114fe412bba43c18a771dcc23ecb0.svg";